export const theme = {
  breakpoints: ['320px', '768px', '1280px'],
  colors: {
    PrimaryWhite: '#FFFFFF',
    PrimaryBlack: '#000000',
    PrimaryOrange: '#FF751D',
    PrimaryGray: '#F5F6FB',
    SecondGray: '#F6F7FB',
    PaleGray: '#C7CCDC',
    TextGray: '#52555F',
    BgGray: '#F2F5FC',
    TabBg: '#FAFBFD',
    BtnBorderGray: '#F6F7FC',
    PaleOrange: '#FFDAC0',
    Red: '#E53935',
    Green: '#407946',
    SVGColor: '#071F41',
    logoGrey: '#52555F',
    placeholderGrey: '#52555F',
    inputErrorRed: '#eb5757',
    bodyColor: '#FFFFFF',
    btnsBorder: 'transparent',
    balanceBorder: '#FFFFFF',
    transactionList: '#FFFFFF',
    iconsFill: '#52555F',
    selectOption: '#F5F6FB',
    datePickerFutureDates: '#C7CCDC',
    statsIconsBg: '#52555F',
    authFormInputText: '#000000',
  },
};

export const darkTheme = {
  breakpoints: ['320px', '768px', '1280px'],
  colors: {
    PrimaryWhite: '#403d39',
    PrimaryBlack: '#FFFFFF',
    PrimaryOrange: '#FF751D',
    PrimaryGray: '#252422',
    SecondGray: '#F6F7FB',
    PaleGray: '#C7CCDC',
    TextGray: '#FFFFFF',
    BgGray: '#1e1603',
    TabBg: '#252422',
    BtnBorderGray: '#F6F7FC',
    PaleOrange: '#FFDAC0',
    Red: '#E53935',
    Green: '#407946',
    SVGColor: '#C7CCDC',
    logoGrey: '#C7CCDC',
    placeholderGrey: '#252422',
    inputErrorRed: '#eb5757',
    bodyColor: '#000000fd',
    btnsBorder: '#C7CCDC',
    balanceBorder: '#C7CCDC',
    transactionList: '#252422',
    iconsFill: '#FFFFFF',
    selectOption: '#C7CCDC',
    datePickerFutureDates: '#1e1603',
    statsIconsBg: '#FFDAC0',
    authFormInputText: '#000000',
  },
};

// background-color: #403d39;
